// Get visible users

export default (users, { text }) => {
    return users.filter((user) => {
        const textMatch = user.fullname.toLowerCase().includes(text.toLowerCase());

        return textMatch;
    });
};